<template>
  <div class="bg">
    <div class="banner">
      <img class="img-100" src="@/assets/img/article/banner@2x.png" alt srcset />
    </div>

    <div class="article">
      <div class="container">
        <div class="row">
          <div class="col-md-2">
            <div class="article-left">
              <div
                class="item"
                :class="activeIndex == index ? 'active' : ''"
                v-for="(item,index) in articleTab"
                :key="index"
                @click="tab(index)"
              >{{item}}</div>
            </div>
          </div>
          <div class="col-md-10">
            <div class="article-date-list">
              <div
                class="container-fluid date-item"
                v-for="(item,index) in articleList"
                :key="index"
                @click="jump(item.url)"
              >
                <div class="row">
                  <div class="col-md-4">
                    <img :src="item.imgUrl" alt srcset />
                  </div>

                  <div class="data-right col-md-8">
                    <div class="text-cut-2 title">{{item.title}}</div>

                    <div class="time">{{item.date}}</div>

                    <div class="con">{{item.con}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import article from "../../assets/articleList";

export default {
  data() {
    return {
      articleTab: ["媒体报道", "行业动态"],
      articleList: [],
      activeIndex: this.$route.query.type
    };
  },
  mounted() {
    if (this.activeIndex == 0) {
      this.articleList = article.meiti;
    } else {
      this.articleList = article.hangye;
    }
  },
  methods: {
    tab(index) {
      console.log(index);
      this.activeIndex = index;
      if (index == 0) {
        console.log(article);
        this.articleList = article.meiti;
      } else {
        this.articleList = article.hangye;
      }
    },
    jump(url) {
      window.open(url, "_blank");
      // this.$router.push({
      //   path: "./articleDetails",
      //   query: {
      //     data: item,
      //     type: this.activeIndex
      //   }
      // });
    }
  }
};
</script>

<style lang='scss'>
.bg {
  background-color: #f5f5f5;
}
.article {
  margin-top: 44px;

  .article-left {
    text-align: center;
    background: #fff;

    .item {
      padding: 30px 0;
      cursor: pointer;
    }

    .active {
      color: #0d9c91;
    }
  }

  .article-date-list {
    padding: 68px 55px;
    background-color: #fff;
    .date-item {
      margin-bottom: 40px;

      .data-right {
        padding: 10px;

        .title {
          font-size: 18px;
        }

        .time {
          font-size: 14px;
          color: #8d8d8d;

          padding: 20px 0 10px 0;
        }

        .con {
          font-size: 14px;
          color: #363636;
        }
      }
    }
  }
}
@media (max-width: 576px) {
  .article {
    .article-left {
      display: flex;

      .item {
        width: 50%;
        padding: 40px 0 20px 0;
      }
    }
    .article-date-list {
      padding: 20px 20px;
    }
  }
}
</style>